<script>
  import { hasCookie, setCookie } from '../../lib/cookieUtil.js';
  import { trackAcknowledge } from '../../lib/trackingUtil.js';
  import Navigation from './components/Navigation.html';
  import MessageBar from './components/MessageBar.html';

  export let navigation = null;
  export let messageBars = [];

  export let requestCookies = null;

  export let transparent = true;
  export let topTransparencyMode = 'transparent';

  export let fixed = true;
  export let colorClassNames = {};
  export let scrollColorClassNames = {};
  export let zIndexClassName = 'mh-default-z-index';
  export let scrollingElementAccessor = () => document.body;
  export let onThirdPartyCookiesAuthorized = () => {};

  const isAcknowledged = ({ options }) => {

    // Always assume cookies are acknowledged during SSR, unless the requestCookies option is specified.
    if (SSR_MODE && requestCookies === null) {
      return true;
    }

    if (['cookie', 'multiLanguage'].includes(options.type)) {
      return hasCookie(options.cookie, requestCookies);
    }

    if (process.env.NODE_ENV === 'development') {
      console.error(`MessageBar type "${options.type}" not implemented`) // eslint-disable-line no-console
    }

    return false;
  }

  const onAcknowledgeWrapper = messageBar => () => {
    if (['cookie', 'multiLanguage'].includes(messageBar.options.type)) {
      setCookie(messageBar.options.cookie);
    } else {
      if (process.env.NODE_ENV === 'development') {
        console.error(`MessageBar type "${messageBar.options.type}" not implemented`) // eslint-disable-line no-console
      }
    }

    let waitForTracking = Promise.resolve()

    if (messageBar.options.trackingMode === 'onAcknowledge') {
      waitForTracking = trackAcknowledge();
    }

    if (messageBar.options.isThirdPartyCookieAcknowledge) {
      waitForTracking.then(onThirdPartyCookiesAuthorized);
    }

    messageBar.acknowledged = true;

    // Update messageBarsState reference to trigger Svelte
    // reactive statements
    messageBarsState = messageBarsState.slice();
  }

  const onDisplayWrapper = messageBar => () => {
    if (messageBar.options.trackingMode === 'onDisplay') {
      trackAcknowledge();
    }
  }

  const clickHandlers = messageBar => {
    if (messageBar.options.type === 'multiLanguage') {
      return {
        [messageBar.options.multiLanguage.updatePreferredLocaleLinkSelector]: () => {
          // Calls the update-preferred-locale endpoint to save the new market to the
          // preferred-locale user attribute. Note if there's an error we don't want to interrupt
          // the redirect, so we don't bother waiting for the response.

          const request = new XMLHttpRequest();
          request.open('GET', messageBar.options.multiLanguage.updatePreferredLocaleUrl, true);
          request.send();
        }
      }
    }

    return {};
  }

  $: messageBarsState = messageBars.map(bar => ({ ...bar, acknowledged: isAcknowledged(bar) }));
  $: allBarsAcknowledged = messageBarsState.every(bar => bar.acknowledged);
</script>

{#each messageBarsState as messageBar, index}
  {#if !messageBar.acknowledged}
    <MessageBar
      messageHTML={messageBar.messageHTML}
      dir={messageBar.dir}
      activeAcknowledgeLabel={messageBar.options.activeAcknowledgeLabel}
      onDisplay={onDisplayWrapper(messageBar)}
      onAcknowledge={onAcknowledgeWrapper(messageBar)}
      clickHandlers={clickHandlers(messageBar)}
    />
  {/if}
{/each}
{#if navigation}
  <Navigation
    {...navigation}
    {colorClassNames}
    {scrollColorClassNames}
    {zIndexClassName}
    {scrollingElementAccessor}
    transparent={transparent && allBarsAcknowledged}
    topTransparencyMode={topTransparencyMode}
    fixed={fixed && allBarsAcknowledged}
  />
{/if}
